const StatusTabs = ({ activeTab, setActiveTab }) => {
  const tabs = ["Active", "Resolved", "Pending"];

  return (
    <div className="flex gap-4 justify-center mt-6">
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => setActiveTab(tab)}
          className={`px-6 py-2 rounded-lg text-sm font-medium
            ${
              activeTab === tab
                ? "bg-[#EEF1FF] text-[#1B3CD6]"
                : "bg-[#F7F8FF] text-[#7A7A7A]"
            }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default StatusTabs;
